import { Component } from '@angular/core';
import { Side } from 'src/app/models/configurators-2d/applications/fence/side';
import { FenceService } from 'src/app/services/configurators-2d/applications/fence.service';

@Component({
  selector: 'ng-fence-side-panel-count',
  templateUrl: './side-panel-count.component.html',
  styleUrl: './side-panel-count.component.scss',
})
export class FenceSidePanelCountComponent {
  sides: Side[];

  constructor(public fenceService: FenceService) {
    this.sides = fenceService.configuration.sides;
  }

  /**
   * Fonction retournant le nombre de panneaux complet pour un côté
   * @param side côté
   */
  getCompletePanelBySide(side: Side): number {
    return side?.panelCount?.completeCount ?? 0;
  }
}
